import React from "react";
import { ArrowUpRight, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import storeLogo from "../assets/images/logo.png";

export default function Footer({ settings }) {
  return (
    <footer className="site-footer" id="story">
      <div className="page-shell">
        <div className="footer-main">
          <div className="footer-brand-block">
            <Link className="brand brand--footer" to="/">
              <img src={storeLogo} alt="Sugam Store" />
              <span><strong>Sugam Store</strong><small>Everyday Essentials</small></span>
            </Link>
            <p>Your trusted destination for everyday essentials, quality picks, and premium customer service with express pan-India delivery.</p>
            <Link className="footer-social" to="/shop">Explore Our Full Catalog <ArrowUpRight size={15} /></Link>
          </div>
          
          <div className="footer-links">
            <h3>Quick Links</h3>
            <Link to="/shop">Shop All Products</Link>
            <Link to="/about">About Us</Link>
            <Link to="/faq">Help & FAQs</Link>
            <Link to="/contact">Contact Support</Link>
          </div>

          <div className="footer-links">
            <h3>Policies</h3>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms">Terms & Conditions</Link>
            <Link to="/shipping-policy">Shipping & Delivery</Link>
            <Link to="/return-policy">Return & Refund Policy</Link>
          </div>

          <div className="footer-links">
            <h3>Customer Care</h3>
            <a href={`mailto:${settings?.general?.supportEmail || "hello@sugamstore.in"}`}>
              <Mail size={15} /> {settings?.general?.supportEmail || "hello@sugamstore.in"}
            </a>
            {settings?.general?.supportPhone && (
              <a href={`tel:${settings.general.supportPhone}`}>
                <Phone size={15} /> {settings.general.supportPhone}
              </a>
            )}
            <p className="footer-timing">Mon - Sat: 9:00 AM - 8:00 PM IST</p>
            <span className="footer-trust-badge">🛡️ 100% Genuine & Verified</span>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} Sugam Store. All rights reserved.</span>
          <span>🔒 256-Bit SSL Encrypted Checkout · Pan-India Express Delivery</span>
        </div>
      </div>
    </footer>
  );
}
